import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="main-footer d-flex justify-content-between align-items-center flex-column flex-md-row px-auto px-md-4">
      <div className="flex-shrink-0 flex-md-shrink-1">{t("footer.copyright")}</div>
      <ul className="footer-nav hstack gap-1 gap-sm-3 flex-shrink-0 flex-md-shrink-1 justify-content-center justify-md-content-end flex-column flex-sm-row mt-2 mt-sm-0 list-unstyled">
        <li>
          {t("footer.version")}. {process.env.REACT_APP_VERSION}
        </li>
        <li>
          <Link to="/privacy">{t("footer.privacyLink")}</Link>
        </li>
        <li>
          <Link to="/terms">{t("footer.termsLink")}</Link>
        </li>
      </ul>
    </footer>
  );
};

export default Footer;
